var _defs, _path, _path2, _rect, _path3, _path4, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{stroke:#000;stroke-miterlimit:10;stroke-width:3px;}.cls-1{opacity:0.7;}.cls-2{fill:#f48d25;}.cls-3{fill:#39291e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1landscape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.34,59.91S-16.48,77.55,5.76,27.84l3.51-6.73c28-46.73,61.58,32.07,61.58,32.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.8,118.4s32,75,58.62,30.53l3.34-6.42C262.94,95.19,183.14,112,183.14,112Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.56,
    y: 18.73,
    width: 12.1,
    height: 134.26,
    transform: "translate(-8.56 157.61) rotate(-62.49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68,55.61S-15.87,73.25,6.38,23.54l3.51-6.73c28-46.73,61.58,32.06,61.58,32.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.41,114.1s32,75,58.63,30.53l3.34-6.42c21.17-47.32-58.63-30.53-58.63-30.53Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 120.17,
    y: 14.43,
    width: 12.1,
    height: 134.26,
    transform: "translate(-4.42 155.84) rotate(-62.49)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddle);
export default __webpack_public_path__ + "static/media/paddle.bb54d8e9094c71978f68d4c93ea37a37.svg";
export { ForwardRef as ReactComponent };